// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__16wEt","notes":"Notes_notes__2U9Ng"};